import { lazy } from 'react'

export const ChatVariant1 = lazy(() => import('./ChatVariant1'))
